import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ToasterrorService {

  constructor(
    public translate: TranslateService,
    private toastr: ToastrService
  ) { }

  validateArticleForm(article, domaine, accepted): boolean {
    const errors = [];

    // check for title
    if (!article.title) {
      errors.push('Title is required.');
    }

    // check for content
    if (accepted.content == false) {
      errors.push(this.translate.instant(`Content is required : Minimum Words=`) + domaine.min_words);
    }

    // check for image
    if (accepted.image == false) {
      errors.push(this.translate.instant(`Image are required : Minimum Images=`) + domaine.min_imgs);
    }

    // check for link
    if (accepted.link == false) {
      errors.push(this.translate.instant(`Link are required : Maximum Links=`) + domaine.max_links);
    }

    // check if accepted terms and conditions
    if (!accepted) {
      errors.push(this.translate.instant('You must fill all items.'));
    }

    // display validation errors in Toastr
    if (errors.length > 0) {
      const errorMessages = errors.map(error => `<li>${error}</li>`).join('');
      this.toastr.warning(`<ul>${errorMessages}</ul>`, this.translate.instant('Form invalid'), {
        enableHtml: true,
      });
      return false;
    }

    return true;
  }
}
